import React, { useEffect, useState } from 'react';

const EditContextDialog = ({ open, item, onClose, onSave }) => {
  const [form, setForm] = useState(null);
  const [saving, setSaving] = useState(false);

  // 🔒 Safe sync when dialog opens
  useEffect(() => {
    if (open && item) {
      setForm({ ...item });
    }
  }, [open, item]);

  if (!open || !form) return null;

  const handleSave = async () => {
    try {
      setSaving(true);
      await onSave(form);
      onClose();
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Edit Context Item</h5>
          <button className="btn-close" onClick={onClose} />
        </div>

        <div className="modal-body">
          <div className="mb-3">
            <label className="form-label">Category</label>
            <input
              className="form-control"
              value={form.category || ''}
              onChange={(e) =>
                setForm({ ...form, category: e.target.value })
              }
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Key Information</label>
            <textarea
              className="form-control"
              rows="4"
              value={form.key_info || ''}
              onChange={(e) =>
                setForm({ ...form, key_info: e.target.value })
              }
            />
          </div>
        </div>

        <div className="modal-footer">
          <button
            className="btn btn-secondary"
            onClick={onClose}
            disabled={saving}
          >
            Cancel
          </button>
          <button
            className="btn btn-primary"
            onClick={handleSave}
            disabled={saving}
          >
            {saving ? 'Saving…' : 'Save Changes'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditContextDialog;
